import styled from "styled-components";

export const DailyQuoteParentContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: ${({ theme }) => theme?.themeC2};
`

export const DailyQuoteMainText = styled.div`
    width: 80%;
    max-width: 1185px;
    font-family: Outfit;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 21px;
    line-height: 28.2px;
    text-align: center;
    color: #FFF;
    padding: 10px 36px 0;

    @media(min-width: 768px){
        font-size: 41px;
        line-height: 50px;
        padding: 20px 56px 0;
    }
    @media(min-width: 1024px){
        font-size: 61px;
        line-height: 73.2px;
        padding: 30px 66px 0;
    }
`

export const DailyQuoteIcon = styled.img`
    width: 36px;
    height: 36px;
    position: relative;
    right: 26px;

    @media(min-width: 768px){
        width: 56px;
        height: 56px;
        right: 46px;
    }
    @media(min-width: 1024px){
        width: 66px;
        height: 66px;
        right: 56px;
    }
`

export const DailyQuoteSeparatorLine = styled.div`
    width: 50%;
    height: 3px;
    background: #FFF;
    margin: 41px auto 0;
    max-width: 590px;

    @media(min-width: 768px){
        margin: 51px auto 0;
    }
    @media(min-width: 1024px){
        margin: 61px auto 0;
    }
`

export const DailyQuoteAuthorText = styled.div`
    margin: 56px auto 10px;
    font-family: Outfit;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #FFF;

    @media(min-width: 768px){
        margin: 76px auto 20px;
        font-size: 26px;
        line-height: 30px;
    }
    @media(min-width: 1024px){
        margin: 96px auto 30px;
        font-size: 32px;
        line-height: 38px;
    }
`